<app-item-list (onSelected)="onUserSelected()"
               [filter]="'user'"
               [isInfinityScrollEnabled]="isInfinityScrollEnabled"
               [isMultiple]="isMultiple"
               [isSelectAllEnabled]="isSelectAllEnabled"
               [items]="users"></app-item-list>
